// FNP-211: query strings sourced from @flexinet/pricing-components so the
// canonical dual-API query shape (Console API for ApplicationProducts,
// Billing API for rich Products) lives in one place. Portal-app keeps its
// own fetch/hook logic because its tenant-admin aggregation across
// applications is a different consumer shape from the library's single-app
// hook — see FNP-211 comment thread for the full architectural picture.
import {
    getProduct,
    listProducts,
} from '@flexinet/pricing-components';
import {GraphQLQuery} from '@aws-amplify/api';
import {
    GetProduct,
    ListProducts
} from "../types";
import {notifyError} from "../../../../components/ServiceNotifications";
import {billingClient} from '../../billing-api-integration/client';

export type {Product} from '../types';

export const fetchProducts = async (variables?: Record<string, unknown>) => {
    try {
        const response = await billingClient.graphql<GraphQLQuery<ListProducts>>({
                                                                              query: listProducts,
                                                                              variables: {...variables},
                                                                          });
        return response.data?.listProducts ?? { items: [], nextToken: '' };
    } catch (e) {
        notifyError(e);
        return { items: [], nextToken: '' };
    }
};

export const fetchProduct = async (id: string) => {
    try {
        const response = await billingClient.graphql<GraphQLQuery<GetProduct>>({
                                                                            query: getProduct,
                                                                            variables: {id: id},
                                                                        });
        return response.data?.getProduct ?? null;
    } catch (e) {
        notifyError(e);
        return null;
    }
};


